// 供应商管理
export default [
  {
    path: "/supplier",
    name: "supplier",
    meta: { title: "供应商管理" },
    component: () => import("../views/supplier/index"),
    children: [
      {
        path: "/supplier/list",
        name: "supplierList",
        meta: { title: "供应商列表", isMenu: true },
        component: () => import("../views/supplier/list"),
      },
      {
        path: "/supplier/audit",
        name: "supplierAudit",
        meta: { title: "供应商审核", isMenu: true },
        component: () => import("../views/supplier/audit"),
      },
      {
        path: "/supplier/detail/supplierDetail",
        name: "supplierDetail",
        meta: { title: "供应商详情" },
        component: () => import("../views/supplier/detail/supplierDetail"),
      },
      {
        path: "/supplier/accounts",
        name: "supplierAccounts",
        meta: { title: "供应商分账", isMenu: true },
        component: () => import("../views/supplier/accounts"),
      },
    ],
  },
]
